
import { parseErrorResponsesDetails } from "./errorHandling";
import {

  type ApiStatusType,
  getApiResponseMapping,
} from "./responseHandling";
import { actions, ActionType } from "../constants/appActions";
export interface PartialSuccessHandler<T> extends ApiStatusType {}

export const parsePartialSuccess = <T>(
  action: any
): PartialSuccessHandler<T> | undefined => {
  // Check if the response indicates MFA is required
  const responseCode = action?.payload?.code;

  if (responseCode === "PartialSuccess") {
    const partialSuccessMapping = getApiResponseMapping(207, "PartialSuccess");
    const errorMessageDetails = parseErrorResponsesDetails(
      action?.payload?.errors
    );

    return {
      status: 207, // Use actual status from response
      code: partialSuccessMapping.code,
      action:
        partialSuccessMapping.action as (typeof actions)[keyof typeof actions],
      actionType:
        partialSuccessMapping.actionType as (typeof ActionType)[keyof typeof ActionType],
      message: action?.payload?.message || partialSuccessMapping.message,
      detail: action?.payload?.detail || partialSuccessMapping.detail,
      showDetails: errorMessageDetails || partialSuccessMapping.showDetails,
    };
  }

  // Return undefined if no Partial Success requirement detected
  return undefined;
};
